/* eslint-disable react/prop-types */
/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconStatus, StatusIconSize} from '../../types/types';

interface Props {
  size?: StatusIconSize;
  type: IconStatus;
  style?: any;
}
/**
 * @StatusIcon
 *
 * Defines the Design Language System (DLS) Status Active, Idle, Issue, Parked and Offline
 * Icon components.
 *
 * ```typescript
 *    import {IconStatus} from '@ion/dls/src/types/types';
 *
 *    <StatusIcon type={IconStatus.active} size={StatusIconSize.small} />
 *    <StatusIcon type={IconStatus.idle} size={StatusIconSize.basic} />
 *    <StatusIcon type={IconStatus.issue} />
 *    <StatusIcon type={IconStatus.parked} />
 *    <StatusIcon type={IconStatus.offline} />
 *
 * ```
 */
export const StatusIcon = ({size = StatusIconSize.basic, type, style}: Props) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill='none' xmlns='http://www.w3.org/2000/svg' style={style}>
    <path d='M8 13C10.7614 13 13 10.7614 13 8C13 5.23857 10.7614 3 8 3C5.23858 3 3 5.23857 3 8C3 10.7614 5.23858 13 8 13Z'
      fill={type as unknown as string} />
  </svg>
);

export default StatusIcon;
